<template lang="pug">
  #top
    .box
      router-view(
        @append_family="append_family"
        @append_child="append_child"
        @remove_child="remove_child"
        @append_parent="append_parent"
        @append_brother="append_brother"
        @append_nephew="append_nephew"
        @append_grand_parent="append_grand_parent"
        @family_state="family_state"
        @go_step02="go_step02"
        @change_family="change_family"
        @change_brother="change_brother"
        @delete_family="delete_family"
        @family_type="family_type"
        @init="init"
        @init_child="init_child"
        @init_parent="init_parent"
        @init_brother="init_brother"
        @clear_brother="clear_brother"
        @redraw_family="redraw_family"
      )
    .box
      FamilyTree(:family="family" :type="type" :redraw="familyRedraw" @go_step02="go_step02")
</template>

<script lang="js">
import FamilyTree from '@/components/page/FamilyTree.vue';
import canvas from '@/module/canvas';

export default {
  data: () => ({
    type: 1,
    familyRedraw: false,
    family: {
      label: '　本人　',
      comment: '遺産をお持ちの方',
      mode: 1,
      spouse: [],
      brother: [],
      parent: [],
    },
  }),
  components: {
    FamilyTree,
  },
  methods: {
    init() {
      this.family.spouse = [];
      this.family.brother = [];
      this.family.parent = [];
      this.familyTreeRedraw();
    },
    init_child() {
      this.family.brother = [];
      this.family.parent = [];
      this.family.spouse[0].children = [];
    },
    init_parent() {
      this.family.parent = [];
    },
    init_brother() {
      this.family.brother = [];
    },
    clear_brother() {
      this.family.brother = [];
    },
    button_start() {
      this.$router.push('/step01_1');
    },
    redraw_family() {
      this.familyTreeRedraw();
    },
    draw() {
      canvas.draw(this.family);
    },
    // 配偶者追加
    append_family(modeData) {
      this.$set(this.family.spouse, this.family.spouse.length, {
        label: '配偶者',
        comment: '',
        mode: modeData,
        exist: false,
        delete: false,
        children: [],
      });
      this.familyTreeRedraw();
    },
    // 子供追加
    append_child() {
      this.family.spouse[0].children.push(
          {
            label: '子',
            comment: '',
            exist: false,
            delete: false,
            grand_child: [],
          },
      );
      this.familyTreeRedraw();
    },
    // 子供クリア
    remove_child() {
      this.family.spouse[0].children = [];
    },
    append_grand_parent(parentID) {
      this.family.parent[parentID].grand_parent = [
        {
          label: '祖父',
          comment: '',
          exist: false,
          delete: false,
        },
        {
          label: '祖母',
          comment: '',
          exist: false,
          delete: false,
        },
      ];
      this.familyTreeRedraw();
    },
    // 親追加
    append_parent() {
      this.family.parent.push(
        {
          label: '父',
          comment: '',
          exist: false,
          delete: false,
          grand_parent: [
            // {
            //   label: '祖父',
            //   comment: '',
            //   exist: false,
            //   delete: false,
            // },
            // {
            //   label: '祖母',
            //   comment: '',
            //   exist: false,
            //   delete: false,
            // },
          ],
        },
      );
      this.family.parent.push(
          {
            label: '母',
            comment: '',
            exist: false,
            delete: false,
            grand_parent: [
              // {
              //   label: '祖父',
              //   comment: '',
              //   exist: false,
              //   delete: false,
              // },
              // {
              //   label: '祖母',
              //   comment: '',
              //   exist: false,
              //   delete: false,
              // },
            ],
          },
      );
      this.familyTreeRedraw();
    },
    // 兄弟追加
    append_brother() {
      this.family.brother.push(
          {
            label: '兄弟・姉妹',
            comment: '',
            exist: false,
            delete: false,
            grand_child: [],
          },
      );
      this.familyTreeRedraw();
    },
    // 甥姪追加
    append_nephew() {
      this.family.brother[0].grand_child.push(
          {
            label: '甥・姪',
            comment: '',
            exist: false,
            delete: false,
          },
      );
      this.familyTreeRedraw();
    },

    // 削除
    delete_family(value) {
      // 兄弟削除
      for (let i = 0; i < value.family.brother.length; i ++) {
        const r1 = value.family.brother[i];
        if (r1.delete) {
          value.family.brother.splice(i, 1);
          i--;
          continue;
        }
        for (let j = 0; j < r1.grand_child.length; j ++) {
          const r2 = r1.grand_child[j];
          if (r2.delete) {
            r1.grand_child.splice(j, 1);
            j--;
          }
        }
      }
      // 配偶者
      for (let i = 0; i < value.family.spouse.length; i ++) {
        const r1 = value.family.spouse[i];
        if (r1.delete) {
          value.family.spouse.splice(i, 1);
          i--;
          continue;
        }
        for (let j = 0; j < r1.children.length; j ++) {
          const r2 = r1.children[j];
          if (r2.delete) {
            r1.children.splice(j, 1);
            j--;
            continue;
          }
          for (let k = 0; k < r2.grand_child.length; k ++) {
            const r3 = r2.grand_child[k];
            if (r3.delete) {
              r2.grand_child.splice(k, 1);
              k --;
            }
          }
        }
      }
      this.family = value.family;
      this.familyTreeRedraw();
    },
    change_family(value) {
      this.family = value.family;
      this.familyTreeRedraw();
    },
    change_brother(value) {
      this.family = value.family;
      this.familyTreeRedraw();
    },
    family_state(state) {
      this.family.spouse[0].exist = state;
      this.familyTreeRedraw();
    },
    family_type(type) {
      this.type = type;
    },
    go_step02() {
      this.$router.push('/step02');
    },
    // 相続関係図更新
    familyTreeRedraw() {
      localStorage.setItem('_isan_data', JSON.stringify(this.family));
      this.familyRedraw = !this.familyRedraw;
    },
  },
  mounted() {
    const json = localStorage.getItem('_isan_data');
    if (json) {
      this.family = JSON.parse(json);
    }
    canvas.init('#canvas');
    this.draw();
  },
};
</script>

<style lang="sass" scoped>
#top
  min-height: calc(100vh - 248px)
  display: flex
  flex-direction: row-reverse
  width: $max-width
  margin: auto
  padding-bottom: 70px
  .box
    min-height: 100%
    width: 50%
    box-sizing: border-box
@media screen and (max-width: $break-header)
  #top
    flex-direction: column
    height: 100%
    min-height: auto
    width: 100%
    .box
      width: 100%
      min-height: auto
      padding: 10px 0
</style>
